<!-- 图形验证码,【注册页面】 -->
<template>
  <a-modal
    :keyboard="false"
    :maskClosable="false"
    :visible="visible"
    :title="$t('图形验证码')"
    :okText="$t('确认')"
    :cancelText="$t('取消')"
    @ok="ok"
    @cancel="cancel"
  >
    <a-form-model ref="ImgCodeForm" :model="form" :rules="rules">
      <a-form-model-item prop="inputCode">
        <a-input v-model.trim="form.inputCode" size="large" :placeholder="$t('请输入图片中的验证码')">
          <template #suffix>
            <div>
              <img v-if="visible" :src="imgCodeUrl" :title="$t('图形验证码')" @click="updateCodeImg" />
            </div>
          </template>
        </a-input>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { checkImgCode } from '@/api/login'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: String,
      default: '',
    },
    emitCodeOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        inputCode: '',
      },
      imgCodeUrl: '',
      rules: {
        inputCode: [
          {
            required: true,
            validator: this.handleCode,
            trigger: 'blur',
          },
        ],
      },
      resCode: '',
      resMsg: '',
    }
  },
  watch: {
    visible(newVisible) {
      if (newVisible) {
        this.updateCodeImg()
      }
    },
  },
  methods: {
    // 取消
    cancel() {
      this.$emit('update:visible', false)
    },
    // 图形验证码验证
    handleCode(rule, value, callback) {
      if (value === '') {
        return callback(new Error(this.$t('请输入图片中的验证码')))
      }
      if (this.resCode === 1) {
        return callback(new Error(this.resMsg))
      }
      callback()
    },
    // 更新图形验证码
    updateCodeImg() {
      this.imgCodeUrl = `${process.env.API_HOST}/api/index/validatecode/${this.phone}?v=${Math.random()}`
    },
    // 输入验证码后确定,正确则直接发送验证码
    async ok() {
      const {
        form: { inputCode },
        phone,
      } = this
      if (this.emitCodeOnly) {
        this.$emit('confimCode', inputCode)
        return
      }
      const { code, msg } = await checkImgCode(phone, inputCode)
      console.log('checkImgCode', code, msg)
      this.$emit('update:visible', false)
      if (code === 1) {
        this.resCode = code
        this.resMsg = msg
        this.updateCodeImg()
        console.log(this.$refs.ImgCodeForm.validateField(['inputCode']))
        // return this.$refs.ImgCodeForm.validateField(['inputCode'])
      }
      if (code === 0) {
        this.$emit('confimCode', true)
      }
    },
  },
}
</script>
